import { serverFetch } from "@core/server";

export function fetchSprKassaList() {
  return serverFetch("sprs/kassa");
}

export function fetchSprKassa(idKassa) {
  return serverFetch(`sprs/kassa/${idKassa}`);
}

export function fetchSprKassaBranches() {
  return serverFetch("sprs/kassa/branches");
}

export function createSprKassa(bodyData) {
  return serverFetch("sprs/kassa", {
    method: "POST",
    bodyData
  });
}

export function saveSprKassa(bodyData) {
  return serverFetch("sprs/kassa", {
    method: "PUT",
    bodyData
  });
}

export function deleteSprKassa(idKassa) {
  return serverFetch(`sprs/kassa/${idKassa}`, {
    method: "DELETE"
  });
}
